import { ProviderRegistrationConsiderationsEnum } from "@asd/customer-portal-api";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { CONSIDERATION_OPTIONS, PROVIDER_REGISTRATION_TITLE_PROPS } from "~/utils/providerRegistrationHelpers";

const Considerations = () => {
  const { control } = useFormContext();

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          What considerations should your employer be aware of?
        </Typography>
        <Controller
          control={control}
          defaultValue={[]}
          name="considerations"
          render={({ field }) => (
            <>
              {CONSIDERATION_OPTIONS.map(([enumValue, label]) => {
                const isThisNone = enumValue === ProviderRegistrationConsiderationsEnum.none;
                const isNoneSelected = field.value.includes(ProviderRegistrationConsiderationsEnum.none);
                const isAnyNonNoneSelected = field.value.some(
                  (value: ProviderRegistrationConsiderationsEnum) => value !== ProviderRegistrationConsiderationsEnum.none,
                );

                const isDisabled = (isNoneSelected && !isThisNone) || (isAnyNonNoneSelected && isThisNone);

                return (
                  <FormControlLabel
                    key={enumValue}
                    control={
                      <Checkbox
                        checked={field.value.includes(enumValue)}
                        disabled={isDisabled}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            field.onChange(field.value.filter((value: ProviderRegistrationConsiderationsEnum) => value !== enumValue));
                          } else {
                            field.onChange([...field.value, enumValue]);
                          }
                        }}
                      />
                    }
                    label={label}
                  />
                );
              })}
            </>
          )}
        />
      </Stack>
    </Stack>
  );
};

export default Considerations;
